var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.subscriptionList, function(apparatus, index) {
        return _c("div", { key: index }, [
          apparatus != undefined && apparatus.isDealerManaged
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "card mt-3",
                    attrs: { "header-bg-variant": "white" }
                  },
                  [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c("h5", { staticClass: "mb-0 pb-0" }, [
                            _c(
                              "span",
                              { attrs: { "data-test-hook": "product-name" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(apparatus.subscriptionProductName) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "row mb-2" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "span",
                            {
                              attrs: {
                                "data-test-hook": "plan-cost-header-text"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
                          )
                        ])
                      ]),
                      _c("h5", { staticClass: "mb-3" }, [
                        _vm._v(
                          _vm._s(apparatus.apparatusName) +
                            " " +
                            _vm._s(_vm.$t("xIsManagedByYourDealer"))
                        )
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-warning",
                          attrs: {
                            type: "button",
                            "data-test-hook": "OpenDealerInfoBtn"
                          },
                          on: {
                            click: function($event) {
                              return _vm.openDealerInfo(apparatus.apparatusId)
                            }
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("xViewDealerInformation")) + " "
                          )
                        ]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          apparatus != undefined && !apparatus.isDealerManaged
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "card mt-3",
                    attrs: { "header-bg-variant": "white" }
                  },
                  [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c("h5", { staticClass: "mb-0 pb-0" }, [
                            _c(
                              "span",
                              { attrs: { "data-test-hook": "product-name" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(apparatus.subscriptionProductName) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      apparatus.subscriptionStatus === 2
                        ? _c("div", [
                            _c("div", { staticClass: "row mb-2" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "billing-date-header-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("xPlanStatus")) + " "
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _c("div", { staticClass: "row mb-4" }, [
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "strong",
                                  {
                                    attrs: { "data-test-hook": "billing-date" }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xPendingCancellation")) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "row mb-2" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "span",
                            {
                              attrs: {
                                "data-test-hook": "plan-cost-header-text"
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("xPlanCost")) + " ")]
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col" }, [
                          _c(
                            "strong",
                            { attrs: { "data-test-hook": "plan-cost" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    "$" +
                                      apparatus.subscriptionCost +
                                      " " +
                                      _vm.displayLegacyPlanCostCycle(
                                        apparatus.subscriptionDuration
                                      )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("div", [
                        _c("div", { staticClass: "row mb-2" }, [
                          _c("div", { staticClass: "col" }, [
                            apparatus.subscriptionStatus === 2
                              ? _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "billing-date-header-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("xPlanEndDate")) + " "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    attrs: {
                                      "data-test-hook":
                                        "billing-date-header-text"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xNextBillingDate")) +
                                        " "
                                    )
                                  ]
                                )
                          ])
                        ]),
                        _c("div", { staticClass: "row mb-4" }, [
                          _c("div", { staticClass: "col" }, [
                            _c(
                              "strong",
                              { attrs: { "data-test-hook": "billing-date" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm
                                        .$moment(
                                          apparatus.subscriptionNextBillingDate
                                        )
                                        .format("MM/DD/YYYY")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "accordion",
                          staticStyle: { width: "100%" },
                          attrs: { role: "tablist" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "accordion-wrapper",
                              staticStyle: {
                                border: "1px solid lightgrey",
                                padding: "10px",
                                "border-radius": "10px"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName: "v-b-toggle",
                                      value:
                                        "collapse-legacy-" +
                                        apparatus.apparatusId,
                                      expression:
                                        "'collapse-legacy-' + apparatus.apparatusId"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "row align-items-center no-gutters"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "col align-items-center"
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fa-regular fa-circle-info pr-2"
                                          }),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("xProductsAndFeatures")
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._m(0, true)
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "b-collapse",
                                {
                                  attrs: {
                                    id:
                                      "collapse-legacy-" + apparatus.apparatusId
                                  }
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("hr", { staticClass: "mx-0 px-0" })
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("p", { staticClass: "mb-0 pb-0" }, [
                                        _c(
                                          "strong",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "products-included-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xProductsIncludedInPlan"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  apparatus.subscriptionProductName
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-0" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: {
                                            "list-style-type": "none",
                                            "padding-inline-start": "13px"
                                          },
                                          attrs: { id: "productsCoveredTanks" }
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.getApparatusIcon(
                                              apparatus.apparatusType
                                            )
                                          }),
                                          _vm._v(
                                            "  " +
                                              _vm._s(apparatus.apparatusName) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row mt-0 mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("p", { staticClass: "mb-0 pb-0" }, [
                                        _c(
                                          "strong",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xFeaturesIncludedInPlan"
                                                  )
                                                ) +
                                                " " +
                                                _vm._s(
                                                  apparatus.subscriptionProductName
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  apparatus.subscriptionProductId ==
                                  _vm.tankUtilityPremiumProductId
                                    ? _c("div", [
                                        _c("div", { staticClass: "row mb-3" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col icon-and-text"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-kit fa-fw fa-tank"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-test-hook":
                                                      "features-included-list"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "xSubFeaturesFmFuelLevelHistoryWarningsBattery"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col icon-and-text"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-fw fa-circle-check"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-test-hook":
                                                      "features-included-monitor-list"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "xFeaturesIncludedTankUtilityAnnuallySubscriptionFeature2"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                    : _c("div", [
                                        _c("div", { staticClass: "row mb-3" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col icon-and-text"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "fa-kit fa-fw fa-generator"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-test-hook":
                                                      "features-included-list"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "xFeaturesInDMHsb1"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]),
                                        _c("div", { staticClass: "row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "col icon-and-text"
                                            },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "far fa-fw fa-circle-check"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  attrs: {
                                                    "data-test-hook":
                                                      "features-included-monitor-list"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "xFeaturePremiumMonitoringForOneHsb"
                                                        )
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ])
                                ]
                              )
                            ],
                            1
                          ),
                          !_vm.purchasedOnWeb
                            ? _c("div", [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: {
                                          "data-test-hook": "manage-plan-text"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("xManagePlanOnApple")
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "row mb-3" }, [
                                  _c("div", { staticClass: "col" }, [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "https://account.apple.com/account/manage/section/subscriptions"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "manage-plan-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  "https://account.apple.com/account/manage/section/subscriptions."
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-warning",
                                    attrs: {
                                      type: "button",
                                      "data-test-hook": "OpenMobileAppBtn"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openMobileApp()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xOpenMobileApp")) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            : apparatus.subscriptionNextBillingDate != null &&
                              apparatus.subscriptionStatus !== 2
                            ? _c("div", { staticClass: "mt-3" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-warning",
                                    attrs: {
                                      type: "button",
                                      title: _vm.$t("xManageYourPlanBtn"),
                                      "data-test-hook": "ManageYourPlanBtn"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.endDate =
                                          apparatus.subscriptionNextBillingDate
                                        _vm.apparatusId = apparatus.apparatusId
                                        _vm.apparatusType =
                                          apparatus.apparatusType
                                        _vm.openModal(
                                          "cancel-subscription-modal"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fas fa-pencil" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("xManageYourPlanBtn")) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _c("div", { staticClass: "row mt-3" }, [
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "auto-renew-message text-small",
                                  attrs: { "data-test-hook": "AutoRenewMsg" }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "xThisSubscriptionWillAutoRenewShortVersion"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ])
                        ]
                      ),
                      apparatus.subscriptionStatus === 2
                        ? _c(
                            "div",
                            [
                              _c(
                                "b-badge",
                                {
                                  staticClass: "mb-2 mt-4 pending-change-badge",
                                  attrs: { variant: "primary" }
                                },
                                [_vm._v(_vm._s(_vm.$t("xPendingChange")))]
                              ),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-test-hook": "no-plan-status"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("xPlanStatus")))]
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "row mb-4" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.$t("xNoPlan")))
                                  ])
                                ])
                              ]),
                              _c("div", { staticClass: "row mb-2" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c(
                                    "span",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "effective-cancel-date"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("xChangeEffectiveDate"))
                                      )
                                    ]
                                  )
                                ])
                              ]),
                              _c("div", { staticClass: "row mb-4" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm
                                          .$moment(
                                            apparatus.subscriptionNextBillingDate
                                          )
                                          .format("MM/DD/YYYY")
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      }),
      _c("CancelSubscriptionModal", {
        attrs: {
          isCancelLegacy: true,
          endDate: _vm.endDate,
          cancelLegacyApparatusId: _vm.apparatusId,
          cancelLegacyApparatusType: _vm.apparatusType,
          cancelSubscriptionApparatuses: [],
          cancelSubscriptionProductId: null,
          cancelSubscriptionStore: null
        }
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("i", { staticClass: "fas fa-chevron-down when-closed" }),
      _c("i", { staticClass: "fas fa-chevron-up when-open" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }